import { footerDataActionTypes } from "./footerDataAction";

const initialState = {
    data: []
}

export const footerDataReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case footerDataActionTypes.SetFooterDataType:
            return { ...state, data: action.payload };
        default:
            return state;
    }
}